import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { getStatusBubblesStyles, COLORS } from "./StatusBubbles.styles";
const StatusBubbles = ({ stageCount, currentStageIndex, stageText, isTerminal = false, isBlocked = false, compact = false, muted = false, }) => {
    const atFinalStage = currentStageIndex >= stageCount - 1;
    const isComplete = atFinalStage && isTerminal;
    const activeColor = muted
        ? COLORS.inactive
        : isComplete
            ? COLORS.complete
            : isBlocked
                ? COLORS.blocked
                : COLORS.active;
    const styles = getStatusBubblesStyles(activeColor, compact);
    return (_jsxs("div", Object.assign({ className: styles.root, "data-testid": "status-bubbles", role: "img", "aria-label": muted
            ? stageText
            : `Stage ${currentStageIndex + 1} of ${stageCount}: ${stageText}` }, { children: [_jsx("div", Object.assign({ className: styles.track }, { children: Array.from({ length: stageCount }, (_, idx) => {
                    const isFilled = idx <= currentStageIndex;
                    return (_jsxs(React.Fragment, { children: [_jsx("div", { className: isFilled ? styles.dotFilled : styles.dotEmpty, "data-testid": `status-dot-${idx}` }), idx < stageCount - 1 && (_jsx("div", { "data-testid": `status-connector-${idx}`, className: idx < currentStageIndex
                                    ? styles.connectorFilled
                                    : styles.connectorEmpty }))] }, idx));
                }) })), _jsx("div", Object.assign({ className: styles.label, "data-testid": "status-bubbles-label" }, { children: stageText }))] })));
};
export default StatusBubbles;
